/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { deleteIncidentCache, toolsStatus } from 'store/modules/tools_status/actions';
import moment from 'moment';
import { ToolsStatusState, ToolsTypes } from 'store/modules/tools_status/types';
import Loader from 'components/atoms/loader';
import ToolModal from 'components/atoms/tool_modal';

const ToolsStatus: React.FC = () => {
  const dispatch = useDispatch();
  const { tools_status, request } = useSelector<ApplicationState, ToolsStatusState>(
    (state) => state.session.tools_status,
  );
  const [showModal, setShowModal] = useState<boolean>(false);
  const [statusLoaded, setStatusLoaded] = useState<boolean>(false);
  const [principalTools, setPrincipalTools] = useState<Array<ToolsTypes>>([]);
  const [incidents, setIncidents] = useState<Array<ToolsTypes>>([]);
  const [monitoringTools, setMonitoringTools] = useState<Array<ToolsTypes>>([]);

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const loadTools = async () => {
    setMonitoringTools(tools_status?.filter((tool) => !tool?.principal_tool));
    setPrincipalTools(tools_status?.filter((tool) => tool?.principal_tool));
    setIncidents(tools_status?.filter((tool) => tool?.status !== 'operational'));
    setStatusLoaded(true);
  };

  useEffect(() => {
    dispatch(toolsStatus());
    document.title = 'Status das Ferramentas - ConLicitação';
  }, []);

  useEffect(() => {
    loadTools();
  }, [request?.loaded]);

  const getStatusTag = (status: string, description: string) => {
    let status_tag = null;

    if (status === 'partial') {
      status_tag = (
        <span className="badge badge-warning pull-right" title={description}>
          Indisponibilidade parcial
        </span>
      );
    } else if (status === 'total') {
      status_tag = (
        <span className="badge badge-danger pull-right" title={description}>
          Indisponibilidade total
        </span>
      );
    } else {
      status_tag = <span className="badge badge-success pull-right">Operacional</span>;
    }

    return status_tag;
  };

  const deleteIncident = async (cache_name: string) => {
    try {
      await dispatch(deleteIncidentCache(cache_name));
      window.location.reload();
    } catch (error) {
      console.error('Erro ao excluir incidente:', error);
    }
  };

  if (!statusLoaded) return <Loader />;

  return (
    <div className="page-container">
      <div className="container py-4">
        <div className="row mb-4">
          <div className="col-md-12">
            <div className="row mb-md-4 mb-2">
              <div className="col-md-12">
                <div className="d-md-flex d-block align-items-center mb-3">
                  <h4 className="mb-1 mr-3 font-weight-bold">Status das Ferramentas</h4>
                  {profile?.alfa_tester && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowModal(true)}
                    >
                      Atualizar status
                    </button>
                  )}
                </div>
                <div id="accordion">
                  <div className="card card-status mb-2">
                    <div className="card-body">
                      <button
                        className="btn btn-link btn-show-filters text-dark p-0 btn-block text-left d-flex justify-content-between"
                        data-toggle="collapse"
                        data-target="#monitoring-portals"
                      >
                        <b>Monitoramento de Chat</b>
                        <i className="material-icons">keyboard_arrow_down</i>
                      </button>
                      <div
                        className="collapse show table-responsive"
                        id="monitoring-portals"
                        data-parent="#accordion"
                      >
                        <ul className="list-group">
                          {monitoringTools?.map((monitoring_tool, index: number) => (
                            <li key={index} className="list-group-item">
                              <div className="d-flex align-items-center">
                                <div className="mr-auto">{monitoring_tool?.tool_name}</div>
                                <div className="p-2">
                                  {getStatusTag(
                                    monitoring_tool?.status,
                                    monitoring_tool?.description,
                                  )}
                                </div>
                                {profile?.alfa_tester && (
                                  <div className="p-0">
                                    <button
                                      className="btn btn-link text-danger btn-lg p-0"
                                      onClick={() => deleteIncident(monitoring_tool?.cache_name)}
                                    >
                                      <span aria-hidden="true">×</span>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {principalTools?.map((principal_tool: ToolsTypes, index) => (
                  <div key={index} className="card card-status mb-2">
                    <div className="card-body d-flex align-items-center">
                      <div className="mr-auto">
                        <b>{principal_tool?.tool_name}</b>
                      </div>
                      <div className="p-2">
                        {getStatusTag(principal_tool?.status, principal_tool?.description)}
                      </div>
                      {profile?.alfa_tester && (
                        <div className="p-0">
                          <button
                            className="btn btn-link text-danger btn-lg p-0"
                            onClick={() => deleteIncident(principal_tool?.cache_name)}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="col-md-12">
                <h4 className="mb-3 mt-3 font-weight-bold">Incidentes</h4>
                {incidents?.map((incident: ToolsTypes, index) => (
                  <div key={index} className="d-flex mb-3">
                    <div className="mr-3">
                      <h2>
                        <i
                          className={`material-icons ${
                            incident?.status === 'partial' ? 'text-warning' : 'text-danger'
                          }`}
                        >
                          error
                        </i>
                      </h2>
                    </div>
                    <div>
                      <h6 className="m-0">{` ${moment(incident?.time).format(
                        'DD/MM/YYYY - HH:mm:ss',
                      )}`}</h6>
                      <p className="m-0">{`Indisponibilidade ${
                        incident?.status === 'partial' ? 'parcial' : 'total'
                      } - ${incident?.description}`}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToolModal
        statusList={[...principalTools, ...monitoringTools]}
        loadTools={loadTools}
        setShowModal={setShowModal}
        showModal={showModal}
      />
    </div>
  );
};
export { ToolsStatus };
